module.exports = __webpack_public_path__ + "img/volumeLarge.39690a73.svg";